import React from "react";
import DevolucionesProveedoresCreate from "./DevolucionesProveedoresCreate";

/** Devolucion de habilitacion: la misma captura por cantidad que la tela. */
export default function DevolucionesProveedoresHabCreate() {
  return <DevolucionesProveedoresCreate tipo="Habilitacion" />;
}
